<template>
    <div class="light-variation">
        <!-- Wide screen layout -->
        <v-menu
            v-if="!$vuetify.breakpoint.xsOnly"
            v-model="menu"
            offset-y
            min-width="175"
            transition="slide-y-reverse-transition"
            attach="#menu-activator-btn"
        >
            <LightVariationItems
                :lightVariationsList="lightVariationsList"
                @select-variation="selectVariation"
            />
        </v-menu>
        <!-- Wide screen layout -->

        <!-- Mobile layout -->
        <v-dialog
            v-else
            v-model="dialog"
            content-class="light-variation-dialog bottom-dialog"
            transition="dialog-bottom-transition"
        >
            <v-card outlined>
                <v-toolbar class="mobile-header">
                    <v-btn
                        icon 
                        @click="dialog = false"
                    >
                        <v-icon black>
                            mdi-close
                        </v-icon>
                    </v-btn>
                    <v-toolbar-title>
                        {{$t('lightVariation.atmosphere')}}
                    </v-toolbar-title> 
                </v-toolbar>  
                <LightVariationItems
                    :lightVariationsList="lightVariationsList"
                    @select-variation="selectVariation"
                />
            </v-card>
        </v-dialog>
        <!-- /Mobile layout -->

        <!-- Light variation CTA -->
        <v-btn
            id="menu-activator-btn"
            class="text-none"
            height="50"
            min-width="50"
            outlined
            @click.prevent="toggleLightVariation"
        >
            <v-icon :left="$vuetify.breakpoint.smAndUp">
                icon-light-variation
            </v-icon>
            <div
                v-if="$vuetify.breakpoint.smAndUp"
                class="desktop-btn" 
            >
                {{ $t('lightVariation.atmosphere') }}
                <v-icon right>
                    mdi-chevron-down
                </v-icon>
            </div>
        </v-btn>
        <!-- Light variation CTA -->
    </div> 
</template>

<script>
    import LightVariationItems from "@/components/lightVariation/LightVariationItems";

    export default {
        name: 'LightVariation',
        props: [
            'lightVariationsList',
        ],
        components: {
            LightVariationItems
        },
        data: () => ({
            menu: false,
            dialog: false,
        }),
        methods: {
            toggleLightVariation() {
                if (!this.$vuetify.breakpoint.xsOnly)
                    this.menu = !this.menu
                else
                    this.dialog = !this.dialog;
            },
            selectVariation(variation) {
                this.$emit('select-variation', variation);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/lightVariation/LightVariation.vue